export default "/assets/markers/undeliverable_off.png"